<template>
  <Info> You do not have access to Seerist </Info>
</template>

<script>
export default {
  name: "Forbidden",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
};
</script>

<style scoped></style>
